(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/together-list.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/together-list.js');
'use strict';

const {
  Link
} = ReactRouterDOM;
const {
  Button
} = svs.ui;
const {
  DocumentTitle,
  widgetArea: {
    WidgetArea
  }
} = svs.components.lbUtils;
const {
  GameList
} = svs.components.marketplace.gameList;
const {
  TeamListContainer
} = svs.components.marketplace.teamList;
const {
  WelcomeNewPlayer
} = svs.marketplace.components.welcome;
const {
  useHistory
} = ReactRouterDOM;
const createPath = '/skapa-lag?returnUrl=/lag';
const TogetherList = _ref => {
  let {
    hasTeams
  } = _ref;
  const loggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const history = useHistory();
  if (!hasTeams) {
    return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
      title: "Spela tillsammans"
    }), React.createElement(WelcomeNewPlayer, {
      isAuthenticated: loggedIn,
      linkTo: createPath
    }), React.createElement(WidgetArea, {
      className: "marketplace-teams-widget-area",
      widgetArea: "teamsWidgetArea"
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
    title: "Spela Tillsammans"
  }), React.createElement("div", {
    className: "bg-sport-50 marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "welcome-team-list-header f-bold f-900"
  }, "Dina lag"), React.createElement("div", {
    className: "welcome-team-list padding-top-1",
    "data-testid": "qa-mkp-customer-teamlist"
  }, React.createElement(TeamListContainer, {
    isHeaderInverted: true,
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true
  }, team => React.createElement(GameList, {
    className: "game-list-welcome",
    fromTeamList: true,
    groupId: team.id,
    hasBottomBorder: true,
    history: history,
    maxGamesToDisplay: 3,
    noFetch: true
  }))), React.createElement("div", {
    className: "welcome-team-list-button-container"
  }, React.createElement(Link, {
    className: "qa-create-team-link",
    to: createPath
  }, React.createElement(Button, {
    block: true,
    className: "qa-create-team-open-button",
    inverted: true
  }, "Starta ett lag"))))), React.createElement(WidgetArea, {
    className: "marketplace-teams-widget-area",
    widgetArea: "teamsWidgetArea"
  }));
};
setGlobal('svs.marketplace.components.welcome.TogetherList', TogetherList);

 })(window);